<template>
  <div class="check-source-stage-info-block">
    <div class="check-source-stage-info-block__header">
      <div class="check-source-stage-info-block__icon">
        <app-icon name="QuestionIcon" size="24px"/>
      </div>
      <div class="check-source-stage-info-block__header-content">
        <div class="check-source-stage-info-block__header-text">
          {{title}}
        </div>
        <span v-if="subtitle.length" class="check-source-stage-info-block__subtitle">{{subtitle}}</span>
      </div>


    </div>

    <div class="check-source-stage-info-block__content">
      <slot />
    </div>
  </div>
</template>

<script>
  export default {
    name: "InfoBlock",
    props: {
      title: {},
      subtitle: {
        type: String,
        default: ""
      }
    }
  }
</script>

<style lang="scss">
.check-source-stage-info-block{
  border: 1px dashed rgba(0, 0, 0, .2);
  padding: 15px 10px;

  &+&{
    margin-top: 15px;
  }

  &__header{
    display: flex;
    align-items: center;
    color: rgba(var(--app-primary), 1);
    margin-bottom: 15px;

    &-text{
      line-height: 1.1;
    }
  }

  &__icon{
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 10px;
  }

  &__subtitle{
    line-height: 1.1;
    color: #627084;
    display: block;
    font-weight: 500;
  }

  &__content{

  }

}
</style>